import { takeLatest } from 'redux-saga/effects';

import { API_REQ_ACTION_TYPES } from 'api/actions';

import fileUploadError from './sagas/fileUploadError';
import fileUploadSuccess from './sagas/fileUploadSuccess';

function* watchersSaga() {
  yield takeLatest(
    [API_REQ_ACTION_TYPES.PRINT_RENDER.UPLOAD_FILE.SUCCESS],
    fileUploadSuccess
  );

  yield takeLatest(
    [API_REQ_ACTION_TYPES.PRINT_RENDER.UPLOAD_FILE.ERROR],
    fileUploadError
  );
}

export default watchersSaga;
